import $ from 'jquery';
import React, { useEffect } from 'react';
// import homeHeroImg from '../img/home-hero-img.png';


import { useImages } from './general/ImageProvider';
import { urlFor } from './lib/imageUrl';


function ParallaxEffect() {
 


  useEffect(() => {
    const iphone = $('#parallax-item');
    const layer = $('#parallax-grp');

    if (iphone.length && layer.length) {
      layer.mousemove(function(e) {
        const ivalueX = (e.pageX * -1 / 30);
        const ivalueY = (e.pageY * -1 / 30);
        console.log('ok');
        iphone.css('transform', 'translate3d(' + ivalueX + 'px,' + ivalueY + 'px, 0)');
        // camera.css('transform', 'translate3d(' + cvalueX + 'px,' + cvalueY + 'px, 0)'); // Assuming camera is defined elsewhere
      });
    }

    // Cleanup function to remove the event listener
    return () => {
      layer.off('mousemove');
    };
  }, []);

  const images = useImages();

  if (!Array.isArray(images) || !images.length) {
    return <div></div>;
  }

  // Helper function to find an image by title
  const getImageByTitle = (title) => {
    return images.find((image) => image.title === title);
  };

  // Fetch specific images by their titles
  
  const heroimg = getImageByTitle('Parallax {Home Hero}');
  
  return (
    <div id="parallax-grp">
      <div id="parallax-item" className="text-end">
      {heroimg && (

<img
  src={urlFor(heroimg.file.asset)}
  alt={heroimg.altText || 'Sanity Image'}
/>

)}      </div>
    </div>
  );
}

export default ParallaxEffect;